import type { VoyagerDetailItem } from '../models/detail-item';

export const FALLBACK_DEMO_DATA: VoyagerDetailItem = {
  id: '20230123_080843_69_24af',
  name: '20230123_080843_69_24af',
  format: 'application/vnd.planet.feature',
  path: 'https://api.planet.com/data/v1/item-types/PSScene/items/20230123_080843_69_24af',
  fullpath:
    'https://api.planet.com/data/v1/item-types/PSScene/items/20230123_080843_69_24af',
  absolute_path:
    'https://api.planet.com/data/v1/item-types/PSScene/items/20230123_080843_69_24af',
  fd__acquired: '2023-01-23T08:20:13Z',
  fi__anomalous_pixels: 0,
  fi__clear_confidence_percent: 92,
  fi__clear_percent: 84,
  fi__cloud_cover: 11,
  fi__cloud_percent: 10,
  fb__ground_control: true,
  fi__gsd: 4,
  fi__heavy_haze_percent: 1,
  fs__instrument: 'PSB.SD',
  fs__item_type: 'PSScene',
  fi__light_haze_percent: 1,
  fi__pixel_resolution: 3,
  fs__provider: 'planetscope',
  fd__published: '2023-05-04T15:09:48Z',
  fs__publishing_stage: 'finalized',
  fs__quality_category: 'standard',
  fi__satellite_azimuth: 279,
  fs__satellite_id: '24af',
  fi__shadow_percent: 4,
  fi__snow_ice_percent: 0,
  fs__strip_id: '6233959',
  fu__sun_azimuth: 97.9,
  fu__sun_elevation: 49.7,
  fd__updated: '2023-05-04T15:09:48Z',
  fu__view_angle: 3.9,
  fi__visible_confidence_percent: 69,
  fi__visible_percent: 89,
  fs_thumbnail_url:
    'https://tiles.planet.com/data/v1/item-types/PSScene/items/20230123_080843_69_24af/thumb',
  agent: 'h18ab829db07',
  fs_agent_extract: 'h18ab829db07',
  has_spatial: true,
  grp_Agency: ['Planet'],
  grp_Organization: ['Planet'],
  grp_Sector: ['Commercial'],
  grp_Data_Theme: ['Orthoimagery'],
  created: '2023-01-23T08:20:13Z',
  grp_Catalog: ['Planet'],
  fs_source: 'SATELLITE',
  grp_Collection: ['PSScene'],
  grp_data_source: ['Planet'],
  grp_Payment_Required: ['Commercial Payment'],
  format_company: 'Planet',
  format_category: 'GIS',
  format_type: 'Service',
  hasMetadata: false,
  location: 'CoordPt2 - Planet',
  area: 0.062019687,
  bbox: '18.115337 -19.259617 18.489701 -19.005828',
  indexed: '2023-10-02T22:04:54.644Z',
  fs_source_location: 'r18aceb5e507',
  fs_vendor: 'Planet',
  fs_platform: 'planetscope',
  properties: ['has_spatial', 'has_thumbnail'],
  views: 2,
  interactions: 2,
  thumb:
    'https://odn.voyagersearch.com/api/rest/content/20230123_080843_69_24af/thumb?format=application%2Fvnd.planet.feature&location=5f83c0467bec77bdba13d897ae405fd7061a361f&path_to_thumb=r18aceb5e507%2Fthumb%2F2%2F023%2F20230123_080843_69_24af.thumb.jpeg&bbox=18.115337+-19.259617+18.489701+-19.005828',
  preview:
    'https://odn.voyagersearch.com/api/rest/content/20230123_080843_69_24af/preview?format=application%2Fvnd.planet.feature&location=5f83c0467bec77bdba13d897ae405fd7061a361f&path_to_preview=r18aceb5e507%2Fthumb%2F2%2F023%2F20230123_080843_69_24af.thumb.jpeg&bbox=18.115337+-19.259617+18.489701+-19.005828',
  download:
    'https://odn.voyagersearch.com/api/rest/download/20230123_080843_69_24af',
  serviceUrl:
    'https://api.planet.com/data/v1/item-types/PSScene/items/20230123_080843_69_24af',
  likes: 0,
  dislikes: 0,
  geo: {
    type: 'Polygon',
    coordinates: [
      [
        [18.156059, -19.005828],
        [18.115337, -19.194142],
        [18.448852, -19.259617],
        [18.489701, -19.070224],
        [18.156059, -19.005828],
      ],
    ],
  },
};
